/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useState, useEffect, useContext, useMemo } from "react";
import { NavLink } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { GlobalContext } from "../../context/GlobalState";
import { getImageURL } from "../../utils/url";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import { useAlert } from "react-alert";
import { useMediaQuery } from "react-responsive";
import Moment from "react-moment";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import Back from "../Icon/Back.jsx";
import SubTabs from "./Components/SubTabs.jsx";
import CompentencyAssessment from "../CompetencyAssessment/Assessment.jsx";
import { parseParamWithQuery } from "../../utils/url.js";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";

const fixName = (name) => {
  const charArrays = ["?", "+", "/"];
  charArrays.forEach((character) => {
    name = name.replaceAll(character, "");
  });
  return name;
};

const Chapters = (props) => {
  document.title = "2xcell.in";
  const alert = useAlert();

  const { userDetails, accountLevelAccess, cbqBetaAccess, setUserDetails } = useContext(GlobalContext);
  const params = useParams();
  const location = useLocation();
  const { subject, subjectId, chapter, chapterId, query } = parseParamWithQuery(
    params,
    "chapterId",
    location.search
  );

  const subjectName = subject;
  const chapterName = fixName(chapter);
  //const chapterId = props.match.params.chapterId;
  window.localStorage.setItem("chapterId", chapterId);
  //const subjectId =  props.match.params.subjectId;
  const sectionIdTask =
    query?.sectionId || localStorage.getItem("sectionIdTask");
  const [questions, setQuestions] = useState([]);
  const [selectedTab, setSelectedTab] = useState("resources");
  const [topics, setTopics] = useState([]);
  const [fetchTopicLoader, setFetchTopicLoader] = useState(true);

  useEffect(() => {
    const getTopics = async () => {
      const authToken = localStorage.getItem("authToken");

      console.log(chapterId, "Dwd");
      try {
        const response = await axios.get(
          // `${process.env.REACT_APP_ORIGIN}/api/v1/chapters/${chapterId}`,
          `${process.env.REACT_APP_ORIGIN2}/api/v1/staffs/${userDetails.userId}/sections/${sectionIdTask}/subjects/${subjectId}/chapters/${chapterId}/topics`,
          {
            headers: {
              token: authToken,
            },
          }
        );
        if (response.data.status === "success") {
          setTopics(response.data.data.topics);
        }
      } catch (error) {
        console.log(error);
      }

      setFetchTopicLoader(false);
    };

    getTopics();
  }, []);

  //convert html, used for url link of each card in different language
  function decodeHTMLEntities(text) {
    var textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  }

  //Function to fix the thumbnail url
  const fixUrl = (url) => {
    url = url.split(" ").join("%20");
    if (
      url.startsWith("https://xcell-cms-files.s3.amazonaws.com") ||
      url.startsWith("https//xcell-cms-files.s3.ap-south-1.amazonaws.com")
    ) {
      return url;
    } else {
      // return "https://xcell-cms-files.s3.amazonaws.com" + url;
      return url;
    }
  };

  const topicCompleteStatus = async (id, setStatus) => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ORIGIN2}/api/v1/staffs/${userDetails.userId}/sections/${sectionIdTask}/subjects/${subjectId}/chapters/${chapterId}/topics/${id}/status`,
        {
          headers: {
            token: authToken,
          },
        }
      );
      if (response.data.status === "success") {
        alert.success(
          response.data.data.completed
            ? "Topic marked complete"
            : "Topic marked incomplete"
        );
        setStatus(response.data.data.completed);
      }
    } catch (error) {
      alert.error(error.message);
      console.log(error);
    }
  };
  const isSmallScreen = useMediaQuery({
    query: "(max-width:450px)",
  });

  const gradeName = useMemo(() => {
    return query?.gradeName || localStorage.getItem("gradeSection")
  },[query]);

  return (
    <>
      <section
        className={
          isSmallScreen
            ? "myResources my-2 p-lg-0 p-4"
            : "myResources my-5 p-lg-0 p-4"
        }
      >
        <div className="container">
          <div
            className="box mb-5"
            style={{ display: isSmallScreen ? "none" : "" }}
          >
            <div className="boxRow">
              <Back
                backPath={`/myresources/${fixName(subjectName)}/${subjectId}${location.search}`}
              />
              <div className="pathDetail" style={{ color: "white" }}>
                <h1>
                  {" "}
                  <NavLink
                    to={{
                      pathname: `/myresources`,
                    }}
                    style={{ color: "white" }}
                  >
                    {gradeName}
                  </NavLink>{" "}
                </h1>
                <h5>
                  <NavLink
                    to={{
                      pathname: `/myresources/${fixName(
                        subjectName
                      )}/${subjectId}${location.search}`,
                    }}
                    style={{ color: "white" }}
                  >
                    {subjectName}
                  </NavLink>{" "}
                  &gt;{" "}
                  <span
                    style={{ color: "white" }}
                  >
                    {chapterName}
                  </span>
                </h5>
              </div>
              <div className="DateBox">
                <h5 className="ms-auto" style={{ fontWeight: "600" }}>
                  <CalendarTodayIcon />{" "}
                  {<Moment format="DD MMMM, YYYY">{new Date()}</Moment>}
                </h5>
              </div>
            </div>
          </div>

          <SubTabs
            show={accountLevelAccess}
            selectedTab={selectedTab}
            selectTab={(tab) => setSelectedTab(tab)}
            buttons={[
              { id: "resources", name: "Learning Resources", show:true },
              { id: "competency-tab", name: "Competency Assessment", show:cbqBetaAccess },
            ]}
          />

          {selectedTab === "resources" ? (
            <div>
              {fetchTopicLoader ? (
                <div className="text-center">
                  <CircularProgress
                    style={{ color: "#FF075B", fontWeight: "600" }}
                  />
                </div>
              ) : (
                <div className="row my-3 gy-4">
                  {topics[0] ? (
                    topics
                      .sort((t1, t2) => t1.priority - t2.priority)
                      .map((topic, index) => (
                        <div
                          className="col-sm-2 cardBox"
                          onClick={() =>
                            setUserDetails({
                              ...userDetails,
                              pathName: {
                                subjectName: `${subjectName}`,
                                chapterName: `${chapterName}`,
                                topicName: `${decodeHTMLEntities(topic.name)}`,
                              },
                            })
                          }
                          key={index}
                          style={{
                            marginBottom: "3rem",
                            textDecoration: "none",
                            display:
                              topic.disabled /*|| isDisabled(topic.modules)*/
                                ? "none"
                                : "block",
                          }}
                        >
                          <NavLink
                            to={`/myresources/${subjectName}/${subjectId}/${chapterName}/${chapterId}/${decodeHTMLEntities(
                              fixName(topic.name)
                            )}/${topic._id}${location.search}`}
                            style={{ textDecoration: "none" }}
                          >
                            {/* <div
                        className='text-center'
                        style={MyResourcesStyle(fixUrl(topic.thumbnail))}
                      > */}
                            <div className="card card-radius card-height boxShadowCard">
                              <div className="card-img">
                                <img
                                  src={
                                    topic.thumbnail
                                      ? getImageURL(fixUrl(topic.thumbnail))
                                      : process.env.PUBLIC_URL +
                                        "/backgrounds/revisionTask/nature.png"
                                  }
                                  className="card-thumbnail"
                                  alt={topic?.name || "chapter"}
                                />
                              </div>
                              <div>
                                <p
                                  className="text-dark text-center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {decodeHTMLEntities(topic.name)}
                                </p>
                              </div>
                            </div>
                          </NavLink>
                          <ToggleSwitch
                            statusFunction={topicCompleteStatus}
                            id={topic._id}
                            completed={topic.completed}
                          />
                        </div>
                      ))
                  ) : (
                    <h3 className="text-center">Create topic</h3>
                  )}
                </div>
              )}
            </div>
          ) : (
            <CompentencyAssessment
              sectionId={sectionIdTask}
              subjectId={subjectId}
              chapterId={chapterId}
              questions={questions}
              setQuestions={setQuestions}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default Chapters;
